import { useContext, useEffect } from 'react';
import { OfferContext } from '../OfferPage';
import { FileText, Plus, Trash2 } from 'react-feather';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DetailTextbox from '../DetailTextbox';
import DetailSectionHeader from '../../../Shared/DetailSection/DetailSectionHeader';
import Button from '../../../../components/Buttons/Button';
import "../FundPage.scss"


const OfferFootnotes = ({ }) => {
    const { offer, setOffer, editMode, setSelectedTab, notes, setNotes, autoFocus, setAutoFocus } = useContext(OfferContext)

    useEffect(() => {
        setSelectedTab("Footnotes")
    }, [])

    function updateNote(value, id, index) {
        const newList = notes.map((note, idx) => {
            if (note.id === id && index === idx) {
                const updatedNote = { ...note, disclosure: value }
                return updatedNote
            } else return note
        })
        setNotes(newList)
        setOffer({ ...offer, disclosures: newList })
    }

    function createNote() {
        const newList = [...notes, { disclosure: '', id: 0 }]
        setAutoFocus(true)
        setNotes(newList)
        setOffer({ ...offer, disclosures: newList })
    }


    function deleteNote(id) {
        const newList = notes.filter(note => note.id !== id)
        setNotes(newList)
        setOffer({ ...offer, disclosures: newList })
    }

    const disclosureList = (data) => data?.length > 0 && data.map((note, index) => {
        const { disclosure, id } = note
        return (
            <PageGridItem container direction='row' gap='s' alignItems='center' style={{ paddingBottom: '1rem' }}>
                <DetailTextbox
                    value={disclosure}
                    update={(e) => updateNote(e.target.value, id, index)}
                    editMode={editMode}
                    placeholder={'Add notes'}
                    minHeight={50}
                    resize='vertical'
                    className='box-style'
                    boxStyle
                    fullWidth
                    autoFocus={id === 0 && index === notes.length - 1 && autoFocus}
                />
                {editMode && <Trash2 onClick={() => deleteNote(id)} className="delete-icon" />}
            </PageGridItem>
        )
    })

    return (
        <>
            <PageGridItem container col="1 / span 6" direction='row' justifyContent='between' alignItems='start'>
                <DetailSectionHeader header="Footnotes" icon={<FileText />} />
                <Button icon={<Plus />} onClick={createNote} disabled={!editMode}>add footnote</Button>
            </PageGridItem>
            <PageGridItem container col="1 / span 6">
                {disclosureList(notes)}
            </PageGridItem>
        </>
    );
}

export default OfferFootnotes;